import API from "../../../services/api";

// ── Catalog ──────────────────────────────────────────────────────────────────
export function getCatalog(family) {
  return API.get("/statutory-reports/catalog", {
    params: family ? { family } : {},
  }).then((r) => r.data);
}

// ── Preview (paginated JSON) ─────────────────────────────────────────────────
export function previewReport(body, { page = 1, pageSize = 50 } = {}) {
  return API.post("/statutory-reports/preview", body, {
    params: { page, page_size: pageSize },
  }).then((r) => r.data);
}

// ── Download (returns a Blob) ────────────────────────────────────────────────
export function downloadReport(body) {
  return API.post("/statutory-reports/download", body, { responseType: "blob" });
}

export function bulkDownload(reports, format = "xlsx") {
  return API.post(
    "/statutory-reports/bulk-download",
    { reports, format },
    { responseType: "blob" }
  );
}

export function downloadArtifact(artifactId) {
  return API.get(`/statutory-reports/artifacts/${artifactId}/download`, {
    responseType: "blob",
  });
}

// ── Async jobs ───────────────────────────────────────────────────────────────
export function generateAsync(body) {
  return API.post("/statutory-reports/generate-async", body).then((r) => r.data);
}

export function getJob(jobId) {
  return API.get(`/statutory-reports/jobs/${jobId}`).then((r) => r.data);
}

// ── History ──────────────────────────────────────────────────────────────────
export function getHistory({ reportKey, limit = 100 } = {}) {
  return API.get("/statutory-reports/history", {
    params: { report_key: reportKey || undefined, limit },
  }).then((r) => r.data);
}

// ── Schedules ────────────────────────────────────────────────────────────────
export function getSchedules() {
  return API.get("/statutory-reports/schedules").then((r) => r.data);
}

export function createSchedule(body) {
  return API.post("/statutory-reports/schedules", body).then((r) => r.data);
}

export function toggleSchedule(scheduleId, active) {
  return API.patch(`/statutory-reports/schedules/${scheduleId}`, { active }).then((r) => r.data);
}

export function deleteSchedule(scheduleId) {
  return API.delete(`/statutory-reports/schedules/${scheduleId}`).then((r) => r.data);
}

// ── Compliance score ─────────────────────────────────────────────────────────
export function getComplianceScore(periodBody) {
  return API.post("/statutory-reports/compliance-score", periodBody).then((r) => r.data);
}

// ── Component map ────────────────────────────────────────────────────────────
export function getComponentMap() {
  return API.get("/statutory-reports/component-map").then((r) => r.data);
}

export function saveComponentMap(mappings) {
  return API.put("/statutory-reports/component-map", { mappings }).then((r) => r.data);
}

// ── Helpers ──────────────────────────────────────────────────────────────────
export function triggerBlobDownload(response, fallbackName = "report") {
  const blob = new Blob([response.data], {
    type: response.headers?.["content-type"] || "application/octet-stream",
  });
  let filename = fallbackName;
  const cd = response.headers?.["content-disposition"];
  if (cd) {
    const m = /filename="?([^"]+)"?/.exec(cd);
    if (m) filename = m[1];
  }
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
